// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// ========================================
// Protect Fitment Table from Convermax Manipulation
// This removes Convermax-specific identifiers so the app doesn't process the table
// ========================================
(function protectFitmentTable() {
  function sanitizeFitmentTable() {
    // Find fitment tables inside our product-fitment-table wrapper
    const tables = document.querySelectorAll('.product-fitment-table #cm-fitment-table, .product-fitment-table .cm_fitment-table');
    
    tables.forEach(function(table) {
      // Skip if already sanitized
      if (table.hasAttribute('data-sanitized')) return;
      table.setAttribute('data-sanitized', 'true');
      
      // Remove the cm-fitment-table ID that Convermax looks for
      if (table.id === 'cm-fitment-table') {
        table.removeAttribute('id');
        table.classList.add('product-fitment-table-content');
      }
      
      // Remove Convermax-specific classes that trigger JS processing
      // but keep the structural classes for our CSS
      const elementsWithCmClasses = table.querySelectorAll('[class*="cm_"], [class*="cmTemplate"], [class*="cmRepeater"]');
      elementsWithCmClasses.forEach(function(el) {
        const classes = Array.from(el.classList);
        classes.forEach(function(cls) {
          // Remove classes that start with cm_ (except cm_fitment which we style)
          // Remove cmTemplate and cmRepeater classes entirely
          if (cls.startsWith('cmTemplate') || cls.startsWith('cmRepeater')) {
            el.classList.remove(cls);
          }
        });
      });
      
      // Remove collapsed class and inline hiding styles
      const collapsedElements = table.querySelectorAll('.collapsed, [style*="height: 0"], [style*="overflow: hidden"]');
      collapsedElements.forEach(function(el) {
        el.classList.remove('collapsed');
        el.style.removeProperty('height');
        el.style.removeProperty('overflow');
        el.style.removeProperty('position');
      });
    });
  }
  
  // Run immediately
  sanitizeFitmentTable();
  
  // Run on DOMContentLoaded (in case script runs before DOM is ready)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sanitizeFitmentTable);
  }
  
  // Run again after a short delay to catch any late-loaded content
  setTimeout(sanitizeFitmentTable, 100);
  setTimeout(sanitizeFitmentTable, 500);
})();

// ========================================
// Fitment Table - View More Functionality (10 rows at a time)
// ========================================
(function() {
  const ROWS_PER_PAGE = 10;

  function initFitmentViewMore() {
    const fitmentTables = document.querySelectorAll('.product-fitment-table');
    
    fitmentTables.forEach(function(tableWrapper) {
      // Skip if already initialized
      if (tableWrapper.hasAttribute('data-fitment-initialized')) return;
      tableWrapper.setAttribute('data-fitment-initialized', 'true');
      
      // Get ALL data rows from ALL fitment containers (there can be multiple)
      // Exclude header rows by targeting only .fitment-table-fitment containers
      const allRows = tableWrapper.querySelectorAll('.fitment-table-fitment .fitment-row');
      const totalRows = allRows.length;
      
      // Only add view more if there are more than ROWS_PER_PAGE rows
      if (totalRows <= ROWS_PER_PAGE) return;
      
      // Mark the table as having view more active
      tableWrapper.classList.add('fitment-table--paginated');
      
      let visibleCount = ROWS_PER_PAGE;
      
      // Initially hide rows beyond the first 10 using CSS class
      updateRowVisibility(allRows, visibleCount);
      
      // Create and insert the View More button
      const buttonWrapper = document.createElement('div');
      buttonWrapper.className = 'fitment-view-more-wrapper';
      
      const viewMoreBtn = document.createElement('button');
      viewMoreBtn.type = 'button';
      viewMoreBtn.className = 'fitment-view-more-btn';
      updateButtonText(viewMoreBtn, totalRows, visibleCount);
      
      buttonWrapper.appendChild(viewMoreBtn);
      
      // Insert button after the table
      const tableContainer = tableWrapper.querySelector('.cm_fitment-table, .fitment-table-container');
      if (tableContainer) {
        tableContainer.after(buttonWrapper);
      } else {
        tableWrapper.appendChild(buttonWrapper);
      }
      
      // Handle click
      viewMoreBtn.addEventListener('click', function() {
        visibleCount = Math.min(visibleCount + ROWS_PER_PAGE, totalRows);
        updateRowVisibility(allRows, visibleCount);
        updateButtonText(viewMoreBtn, totalRows, visibleCount);
        
        // Hide button if all rows are visible
        if (visibleCount >= totalRows) {
          buttonWrapper.style.display = 'none';
        }
      });
    });
  }

  function updateRowVisibility(rows, visibleCount) {
    for (var i = 0; i < rows.length; i++) {
      if (i < visibleCount) {
        rows[i].classList.remove('fitment-row--hidden');
      } else {
        rows[i].classList.add('fitment-row--hidden');
      }
    }
  }

  function updateButtonText(button, totalRows, visibleCount) {
    const remaining = totalRows - visibleCount;
    if (remaining > 0) {
      button.textContent = 'View More (' + remaining + ' remaining)';
    }
  }

  // Initialize after sanitization is complete
  function scheduleInit() {
    setTimeout(initFitmentViewMore, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleInit);
  } else {
    scheduleInit();
  }
})();

// ========================================
// Suspension Table - View More Functionality (5 rows at a time)
// ========================================
(function() {
  var ROWS_PER_PAGE = 5;

  function initSuspensionViewMore() {
    var suspensionTables = document.querySelectorAll('.cm_suspension_table, #cm-suspension-table');

    suspensionTables.forEach(function(tableWrapper) {
      if (tableWrapper.hasAttribute('data-suspension-initialized')) return;
      tableWrapper.setAttribute('data-suspension-initialized', 'true');

      var allRows = tableWrapper.querySelectorAll('.suspension-table-data .suspension-row');
      var totalRows = allRows.length;

      if (totalRows <= ROWS_PER_PAGE) return;

      var visibleCount = ROWS_PER_PAGE;

      updateRowVisibility(allRows, visibleCount);

      var buttonWrapper = document.createElement('div');
      buttonWrapper.className = 'suspension-view-more-wrapper';

      var viewMoreBtn = document.createElement('button');
      viewMoreBtn.type = 'button';
      viewMoreBtn.className = 'suspension-view-more-btn';
      updateButtonText(viewMoreBtn, totalRows, visibleCount);

      buttonWrapper.appendChild(viewMoreBtn);

      var tableContainer = tableWrapper.querySelector('.suspension-table-container');
      if (tableContainer) {
        tableContainer.after(buttonWrapper);
      } else {
        tableWrapper.appendChild(buttonWrapper);
      }

      viewMoreBtn.addEventListener('click', function() {
        visibleCount = Math.min(visibleCount + ROWS_PER_PAGE, totalRows);
        updateRowVisibility(allRows, visibleCount);
        updateButtonText(viewMoreBtn, totalRows, visibleCount);

        if (visibleCount >= totalRows) {
          buttonWrapper.style.display = 'none';
        }
      });
    });
  }

  function updateRowVisibility(rows, visibleCount) {
    for (var i = 0; i < rows.length; i++) {
      if (i < visibleCount) {
        rows[i].classList.remove('suspension-row--hidden');
      } else {
        rows[i].classList.add('suspension-row--hidden');
      }
    }
  }

  function updateButtonText(button, totalRows, visibleCount) {
    var remaining = totalRows - visibleCount;
    if (remaining > 0) {
      button.textContent = 'View More (' + remaining + ' remaining)';
    }
  }

  function scheduleInit() {
    setTimeout(initSuspensionViewMore, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleInit);
  } else {
    scheduleInit();
  }
})();

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  applyZeroPriceProductState(evt.detail.variant);
});

// ========================================
// Linked variant options
// Keep all option values visible. When a selection creates an invalid
// combo, auto-switch the other option(s) to a valid available match.
// ========================================
(function initLinkedVariantOptions() {
  var WRAPPER_SELECTOR =
    '.product__variants-wrapper[data-enable-dynamic-product-options="true"]';

  function getWrappers(root) {
    var scope = root || document;
    return Array.prototype.slice.call(scope.querySelectorAll(WRAPPER_SELECTOR));
  }

  function getSelects(wrapper) {
    return Array.prototype.slice.call(
      wrapper.querySelectorAll("select.dynamic-variant-input")
    );
  }

  function parseVariants(wrapper) {
    var jsonEl = wrapper.querySelector("[data-variant-json]");
    if (!jsonEl) return null;
    try {
      return JSON.parse(jsonEl.textContent);
    } catch (e) {
      return null;
    }
  }

  function selectionMatchesVariant(variant, selectedValues) {
    return selectedValues.every(function (value, index) {
      return variant.options[index] === value;
    });
  }

  function findAvailableVariant(variants, selectedValues) {
    return (
      variants.find(function (variant) {
        return (
          variant.available && selectionMatchesVariant(variant, selectedValues)
        );
      }) || null
    );
  }

  function findVariantForChangedOption(variants, selectedValues, changedIndex) {
    var changedValue = selectedValues[changedIndex];

    function matchesChanged(variant) {
      return variant.options[changedIndex] === changedValue;
    }

    var availableMatches = variants.filter(function (variant) {
      return variant.available && matchesChanged(variant);
    });

    // Prefer keeping other options when they still work with the new value
    for (var preserveUntil = changedIndex - 1; preserveUntil >= 0; preserveUntil--) {
      var preserved = availableMatches.filter(function (variant) {
        for (var i = 0; i <= preserveUntil; i++) {
          if (variant.options[i] !== selectedValues[i]) return false;
        }
        return true;
      });
      if (preserved.length) return preserved[0];
    }

    if (availableMatches.length) return availableMatches[0];

    // Fall back to any matching variant (may be sold out)
    return variants.find(matchesChanged) || null;
  }

  function syncOptionUI(select, value) {
    var optionBlock = select.closest("[data-product-option]");
    if (optionBlock) {
      var label = optionBlock.querySelector("[data-selected-value-for-option]");
      if (label) label.textContent = value;
    }

    var buttonGroup = select.closest("[data-option-buttons]");
    if (!buttonGroup) return;

    Array.prototype.forEach.call(
      buttonGroup.querySelectorAll("[data-button]"),
      function (button) {
        var handle = button.getAttribute("data-option-handle");
        var optionEl = handle
          ? select.querySelector('[data-value-handle="' + handle + '"]')
          : null;
        var isSelected = optionEl
          ? optionEl.value === value
          : button.getAttribute("data-option-value") === value;
        button.classList.toggle("selected", isSelected);
      }
    );
  }

  function applyVariantToSelects(selects, variant) {
    selects.forEach(function (select, index) {
      var nextValue = variant.options[index];
      if (select.value !== nextValue) {
        select.value = nextValue;
      }
      syncOptionUI(select, nextValue);
    });
  }

  function ensureValidSelection(variants, selects, changedSelect) {
    var selectedValues = selects.map(function (select) {
      return select.value;
    });

    if (findAvailableVariant(variants, selectedValues)) return;

    var changedIndex = changedSelect ? selects.indexOf(changedSelect) : 0;
    if (changedIndex < 0) changedIndex = 0;

    var match = findVariantForChangedOption(
      variants,
      selectedValues,
      changedIndex
    );
    if (!match) return;

    applyVariantToSelects(selects, match);
  }

  function initWrapper(wrapper) {
    if (wrapper.getAttribute("data-linked-options-bound") === "true") return;

    var variants = parseVariants(wrapper);
    var selects = getSelects(wrapper);
    if (!variants || selects.length < 2) return;

    wrapper.setAttribute("data-linked-options-bound", "true");

    selects.forEach(function (select) {
      select.addEventListener(
        "change",
        function (event) {
          // Capture phase runs before ProductForm so ATC/price see the corrected combo
          ensureValidSelection(variants, selects, event.target);
        },
        true
      );
    });

    ensureValidSelection(variants, selects, null);
  }

  function initAll(root) {
    getWrappers(root).forEach(initWrapper);
  }

  document.addEventListener("quickview:loaded", function () {
    initAll(document);
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }
})();

// ========================================
// Zero Price Tag Products (zeroprice / btrclick)
// Hide add-to-cart and show "Choose an option" until a paid variant is selected
// ========================================
(function () {
  function isZeroPricePendingVariant(variant) {
    return variant && variant.price === 0;
  }

  function getZeroPriceProducts() {
    return document.querySelectorAll('[data-zero-price-tag="true"]');
  }

  window.applyZeroPriceProductState = function (variant) {
    getZeroPriceProducts().forEach(function (product) {
      var chooseLabel =
        product.getAttribute("data-zero-price-choose-label") || "Choose an option";
      var pending = isZeroPricePendingVariant(variant);

      product.classList.toggle("product--zero-price-pending", pending);

      if (pending) {
        product.querySelectorAll("[data-price]").forEach(function (el) {
          el.textContent = chooseLabel;
        });
        product.querySelectorAll("[data-compare-price]").forEach(function (el) {
          el.textContent = "";
        });
      }
    });
  };

  function bindZeroPriceForms(product) {
    if (product.hasAttribute("data-zero-price-form-bound")) return;
    product.setAttribute("data-zero-price-form-bound", "true");

    var form = product.querySelector("[data-product-form]");
    if (form) {
      form.addEventListener("submit", function (e) {
        if (product.classList.contains("product--zero-price-pending")) {
          e.preventDefault();
        }
      });
    }
  }

  function initZeroPriceProducts() {
    getZeroPriceProducts().forEach(bindZeroPriceForms);
  }

  function blockProtectedListingQuickAdd(event) {
    var quickAddBtn = event.target.closest('[data-quick-shop-trigger="quick-add"]');
    if (!quickAddBtn) return;

    var card = quickAddBtn.closest("[data-zero-price-protected]");
    if (!card) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    var productLink = card.querySelector('a[href*="/products/"]');
    if (productLink) {
      window.location.href = productLink.href;
    }
  }

  function blockProtectedListingFormSubmit(event) {
    var form = event.target.closest(".product-item__product-form");
    if (!form) return;

    var card = form.closest("[data-zero-price-protected]");
    if (!card) return;

    event.preventDefault();
    event.stopPropagation();
  }

  document.addEventListener("click", blockProtectedListingQuickAdd, true);
  document.addEventListener("submit", blockProtectedListingFormSubmit, true);

  document.addEventListener("quickview:loaded", initZeroPriceProducts);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initZeroPriceProducts);
  } else {
    initZeroPriceProducts();
  }
})();

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});

// ========================================
// Filter lists with >10 options use CSS scroll (.filter-drawer__list--scrollable)
// Show a small bottom hint until the shopper reaches the end of the list.
// ========================================
(function() {
  function updateScrollHint(wrapper) {
    const list = wrapper.querySelector('.filter-drawer__list--scrollable');
    if (!list) return;

    const atBottom = list.scrollTop + list.clientHeight >= list.scrollHeight - 2;
    wrapper.classList.toggle('is-at-bottom', atBottom);
  }

  function initFilterListScrollHints() {
    document.querySelectorAll('[data-filter-list-scroll]').forEach(function(wrapper) {
      if (wrapper.hasAttribute('data-scroll-hint-initialized')) {
        updateScrollHint(wrapper);
        return;
      }

      const list = wrapper.querySelector('.filter-drawer__list--scrollable');
      if (!list) return;

      wrapper.setAttribute('data-scroll-hint-initialized', 'true');
      list.addEventListener('scroll', function() {
        updateScrollHint(wrapper);
      }, { passive: true });
      updateScrollHint(wrapper);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFilterListScrollHints);
  } else {
    initFilterListScrollHints();
  }

  document.addEventListener('collection:filter-update', initFilterListScrollHints);

  const observer = new MutationObserver(function(mutations) {
    for (let i = 0; i < mutations.length; i++) {
      const mutation = mutations[i];
      for (let j = 0; j < mutation.addedNodes.length; j++) {
        const node = mutation.addedNodes[j];
        if (node.nodeType === 1 && node.querySelector && node.querySelector('[data-filter-list-scroll]')) {
          initFilterListScrollHints();
          return;
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
